<script setup lang="ts">
import type { ComponentProductPromoCodeProps } from "./ComponentProductPromoCode.props"
const props = defineProps<ComponentProductPromoCodeProps>()

const { applyCoupon } = useCart()
const { addNotification } = useNotification()
const { t } = useI18n()

const handleApply = async () => {
  if (!props.promoCode) return

  try {
    await applyCoupon(props.promoCode)

    addNotification({
      id: Math.random(),
      type: "success",
      notificationAlertText: t("discounts.codeAppliedSuccessfully"),
      isWithCloseIcon: true
    })
  } catch (error) {
    addNotification({
      id: Math.random(),
      type: "warning",
      notificationAlertText: t("discounts.codeAppliedError"),
      isWithCloseIcon: true
    })
  }
}
</script>

<template>
  <div
    v-if="props.promoCode"
    class="
      mb-3
      rounded-sm
      bg-[url('/images/bg-product-promo-code.png')]
      bg-cover
      bg-center
      bg-no-repeat
      p-6
      text-center
    "
  >
    <div
      v-if="props.discounts && props.discounts.length > 0"
      class="flex flex-col gap-2"
    >
      <div class="grid grid-cols-1 gap-2">
        <div
          v-for="(discount, index) in props.discounts"
          :key="index"
          class="flex items-center justify-center"
        >
          <UtilsMarkdown
            class="
              elephant-bold
              text-grey-600
              markdown__strong-red-main-first-child
            "
            :content="discount"
          />
        </div>
        <div class="mt-4">
          <UtilsMarkdown
            v-if="props.condizioni"
            class="pig text-black-main mb-2 px-6"
            :content="props.condizioni"
          />
        </div>

        <div class="mt-2">
          <UtilsMarkdown
            class="mouse-bold text-black-80 mb-2 uppercase"
            :content="$t('promoCodes.product.description')"
          />

          <UtilsButton
            theme="contained-white"
            class="bg-white w-full px-6"
            class-text="!text-green-main !pig-bold uppercase"
            :text="props.promoCode"
            @click="handleApply"
          />
        </div>
      </div>
    </div>
  </div>
</template>
